var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form",
    { on: { submit: _vm.onSubmit } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: `input-group-question`,
                    "label-for": `input-question`,
                    label: `Question ${_vm.form.id}`,
                  },
                },
                [
                  _c("b-form-textarea", {
                    attrs: {
                      id: `input-question`,
                      maxlength: "125",
                      type: "text",
                      placeholder: "Exemple : Quel jour sommes-nous ?",
                      required: "",
                    },
                    model: {
                      value: _vm.form.question,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "question", $$v)
                      },
                      expression: "form.question",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-right" }, [
                    _vm._v(
                      _vm._s(`${_vm.questionLength}
             / 125 caractères restants`) + "\n        "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: `input-group-answer`,
                    "label-for": `input-answer`,
                    label: "Réponse attendue",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: `input-answer`,
                      placeholder: "Exemple : Lundi",
                      type: "text",
                      required: "",
                    },
                    model: {
                      value: _vm.form.answer,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "answer", $$v)
                      },
                      expression: "form.answer",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: `input-group-false1`,
                    "label-for": `index-false1`,
                    label: "Mauvaise réponse 1",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: `index-false1`,
                      type: "text",
                      placeholder: "Exemple : Septembre",
                      required: "",
                    },
                    model: {
                      value: _vm.form.false_1,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "false_1", $$v)
                      },
                      expression: "form.false_1",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: `input-group-false2`,
                    "label-for": `index-false2`,
                    label: "Mauvaise réponse 2",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: `index-false2`,
                      type: "text",
                      placeholder: "Exemple : En 2021",
                      required: "",
                    },
                    model: {
                      value: _vm.form.false_2,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "false_2", $$v)
                      },
                      expression: "form.false_2",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: `input-group-explanation`,
                    "label-for": `input-explanation`,
                    label: "Explication",
                  },
                },
                [
                  _c("b-form-textarea", {
                    attrs: {
                      id: `input-explanation`,
                      type: "text",
                      maxlength: "550",
                      placeholder:
                        "Exemple : Le premier jour du reste de ta vie. C'est un matin comme tous les autres. Un nouveau pari. Rechercher un peu de magie dans cette inertie morose.",
                      required: "",
                    },
                    model: {
                      value: _vm.form.explanation,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "explanation", $$v)
                      },
                      expression: "form.explanation",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-right" }, [
                    _vm._v(
                      _vm._s(`${_vm.explanationLength}
             / 550 caractères restants`) + "\n        "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                { attrs: { label: "Image" } },
                [
                  _c("b-form-file", {
                    attrs: {
                      state: Boolean(_vm.form.img),
                      placeholder: "Choisissez un fichier ou déposez-le ici...",
                      "drop-placeholder": "Déposez-le ici...",
                    },
                    model: {
                      value: _vm.form.img,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "img", $$v)
                      },
                      expression: "form.img",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("b-alert", { attrs: { show: "", variant: "info" } }, [
                _vm._v(
                  "\n        Si vous ne choisissez pas de nouvelle image, l'ancienne sera conservée\n      "
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", [
            _vm.form.img
              ? _c("div", { staticClass: "mt-3" }, [
                  _vm._v(
                    "\n        Fichier sélectionné: " +
                      _vm._s(_vm.form.img ? _vm.form.img.name : "") +
                      "\n      "
                  ),
                ])
              : _vm._e(),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("b-row"),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "text-center" },
            [
              _c(
                "b-button",
                {
                  attrs: {
                    disabled: _vm.pending,
                    type: "submit",
                    variant: "primary",
                  },
                },
                [
                  _vm.pending
                    ? _c(
                        "span",
                        [
                          _c("b-spinner", {
                            attrs: { small: "", variant: "light" },
                          }),
                        ],
                        1
                      )
                    : _c("span", [_vm._v("\n          Enregistrer\n        ")]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }